import { Alert } from "antd";
import React from "react";
import { useSelector } from "react-redux";

export const EnEsperaUsuario = () => {
  const { enEsperaUsuario } = useSelector(
    (state) => state.detalleReducer.asistencia
  );

  if (enEsperaUsuario )
    return <Alert
      style={{ marginBottom: 10 }}
      message="Servicio en espera de usuario"
      type="warning"
      showIcon
      
    />;

  return <>{enEsperaUsuario}</>;
};
